import { FormControl } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, MouseEvent } from '@agm/core';
// import { } from '@types/googlemaps';

@Component({
  selector: 'app-google-location-modal',
  templateUrl: './google-location-modal.component.html',
  styleUrls: ['./google-location-modal.component.scss']
})
export class GoogleLocationModalComponent implements OnInit {

  @ViewChild('search') public searchElementRef: ElementRef;
  private geoCoder;
  public marker = { latitude: null, longitude: null };
  public zoom: number;
  public address: string;

  constructor(
    public activeModal: NgbActiveModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }


  ngOnInit(): void {
    this.findAddress();
  }

  findAddress() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry == null) {
            return;
          }
          this.address = place.formatted_address;
          //  this.web_site = place.website;
          //  this.name = place.name;
          //set latitude, longitude and zoom
          this.marker = { latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng() }
          this.zoom = 12;
        });
      });
    });
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.latitude = position.coords.latitude;
        this.marker.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress({ lat: position.coords.latitude, lng: position.coords.longitude });
      });
    }
  }


  getAddress(location) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: location }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  markerDragEnd($event: MouseEvent) {
    this.marker.latitude = $event.coords.lat;
    this.marker.longitude = $event.coords.lng;
    this.getAddress($event.coords);
  }

  closeModal(marker, address) {
    this.activeModal.close({ marker: marker, address: address ?? null });
  }


  // geocode(address: string): Promise<any> {

  //   return new Promise((resolve, reject) => {
  //     geocoder.geocode({ address: address },
  //       (results, status) => {
  //         if (status === google.maps.GeocoderStatus.OK) {
  //           resolve(results[0]);
  //         } else {
  //           reject(new Error(status));
  //         }
  //       }
  //     );
  //   });
  // }

}
